import { ColorKeys } from '@droplet-tech-code/core-elements/module/theme';
import { LoadingIndicator } from '@droplet-tech-code/core-elements/module/ui/Loading';
import { AppViewProps, View } from '@droplet-tech-code/core-elements/module/ui/View';

export const Pill = (props: PillProps) => {
  if (props.isLoading) {
    return <LoadingIndicator />;
  }
  return (
    <View px="2.5" py="0.5" b={1} br={15} bc={props.color} {...props}>
      {props.children}
    </View>
  );
};

interface PillProps extends AppViewProps {
  color?: ColorKeys;
  isLoading?: boolean;
}
